const isElementInViewport = (el: { getBoundingClientRect: () => any }) => {
  const rect = el.getBoundingClientRect();
  const parrentEL = document.querySelector<HTMLElement>('.react-pdf__Document');
  const parentRect = parrentEL?.getBoundingClientRect();
  return parentRect ? rect.bottom - parentRect.bottom + 24 >= 0 : true;
};

export const inElementInViewport = (pages: Element[]) => {
  for (const el of pages) {
    if (isElementInViewport(el)) return el.getAttribute('data-page-number');
  }
};
